import { render } from "./CountdownTimer.vue?vue&type=template&id=234c7f2c&scoped=true&ts=true"
import script from "./CountdownTimer.vue?vue&type=script&lang=ts"
export * from "./CountdownTimer.vue?vue&type=script&lang=ts"

import "./CountdownTimer.vue?vue&type=style&index=0&id=234c7f2c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234c7f2c"]])

export default __exports__